import { render, staticRenderFns } from "./SupplierVoucherDetails.vue?vue&type=template&id=942da6d0"
import script from "./SupplierVoucherDetails.vue?vue&type=script&lang=js"
export * from "./SupplierVoucherDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports